import React from "react";

const Pricing = ({ plans }) => {
  return (
    <section id="pricing" className="py-16 px-8 bg-white">
      <h3 className="text-3xl font-bold mb-10 text-center text-red-500">
        Pricing Plans
      </h3>
      <div className="grid md:grid-cols-3 gap-8 max-w-6xl mx-auto">
        {plans.map((plan, index) => (
          <div
            key={index}
            className="border border-gray-300 p-8 rounded-lg shadow hover:shadow-lg transition"
          >
            <h4 className="text-2xl font-semibold mb-4">{plan.name}</h4>
            <p className="text-4xl font-bold mb-4">{plan.price}</p>
            <ul className="text-gray-600 mb-6">
              {plan.features.map((feature, i) => (
                <li key={i}>- {feature}</li>
              ))}
            </ul>
            <button className="bg-red-500 text-white px-6 py-2 rounded hover:bg-red-600">
              {plan.cta}
            </button>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Pricing;
